import React from 'react';
import { motion } from 'framer-motion';

const milestones = [
  {
    title: 'Standardized Cultivation Blueprint',
    description: 'We have standardized our cultivation blueprint to protect consistency and capital across every new parcel.',
  },
  {
    title: 'Right-Sized Farm Parcels',
    description: 'Right-sized our farm parcels for genuine operational control — not oversized ambitions, but manageable, high-quality production.',
  },
  {
    title: 'Self-Sustaining Labour Team',
    description: 'Built a self-sustaining, increasingly skilled labour team that manages end-to-end farm operations.',
  },
];

const GoingForward = () => {
  return (
    <section className="py-16 md:py-24 bg-white" id="going-forward">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-[rgb(2,58,16)] mb-4">What This Means Going Forward</h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto font-serif mb-4">
            Each production cycle has hardened our infrastructure, de-risked our operations, and shifted us from experimental farming to a disciplined, market-ready production system.
          </p>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto font-serif mb-4">
            We have standardized our cultivation blueprint to protect consistency and capital, right-sized our farm parcels for genuine operational control, and built a self-sustaining, increasingly skilled labour team.
          </p>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto font-serif">
            This is the operational foundation every new farming partner steps into — not a pitch built on projections alone, but a model refined through three real seasons of hands-on agricultural experience.
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {milestones.map((item, index) => (
            <motion.div
              key={index}
              className="relative bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-8 border border-green-100 shadow-md hover:shadow-lg transition-shadow duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              viewport={{ once: true }}
            >
              <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mb-4">
                <span className="text-white text-xl font-bold">{index + 1}</span>
              </div>
              <h3 className="text-xl font-bold text-[rgb(2,58,16)] mb-3">{item.title}</h3>
              <p className="text-gray-700 font-serif text-sm leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GoingForward;
